/* eslint-disable tss-unused-classes/unused-classes */
import React from 'react'
import { MetricType } from '../../../models/dashboard.model'
import { CostChartLegend } from './CostChartLegend'
import { EnergyChartLegend } from './EnergyChartLegend'

export interface ChartLegendProps {
  isEdisonConnect: boolean
  metric: MetricType
}

/**
 * Chart legend component displays legend for e-mobility dashboard chart.
 *
 * Based on user-selection of metric to be shown(either "cost" or "energy") it conditionally
 * renders a different legend corresponding to each metric.
 *
 * Additionally, should crash in case a new metric is added to make sure the legend is implemented
 * at the same time to ensure the chart stays fully functional.
 *
 * @param - isEdisonConnect as boolean
 */
export const ChartLegend: React.FC<ChartLegendProps> = ({ isEdisonConnect, metric }) => {
  switch (metric) {
    case MetricType.Energy:
      return <EnergyChartLegend showDischargeIndicator={isEdisonConnect} />
    case MetricType.Cost:
      return <CostChartLegend shouldDisplayDischargeIndicator={isEdisonConnect} />
  }
}
